<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (fluidTypeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Fluid Type Source Side:</label>
              <select class="halfWidthInputField" #fluidTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(fluidTypeSelection.Name)"
                (change)="selectionChanged(fluidTypeSelection, fluidTypeInput.value)"
                [value]="fluidTypeSelection.Value.toString()">
                @for (allowable of fluidTypeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="fluidTypeSelection.Value && fluidTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (antifreezeConcentrationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Antifreeze:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="antifreezeConcentrationSelection.Value"
                (change)="textSelectionChanged(antifreezeConcentrationSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(antifreezeConcentrationSelection.Name)"/>
              <label class="units-label">%</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadTypeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Type:</label>
              <select class="halfWidthInputField" #loadTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(loadTypeSelection.Name)"
                (change)="selectionChanged(loadTypeSelection, loadTypeInput.value)"
                [value]="loadTypeSelection.Value.toString()">
                @for (allowable of loadTypeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="loadTypeSelection.Value && loadTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (sourceFluidFlowSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Source Fluid Flow:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="sourceFluidFlowSelection.Value"
                (change)="textSelectionChanged(sourceFluidFlowSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(sourceFluidFlowSelection.Name)"/>
              <label class="units-label">GPM</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadFluidFlowSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Fluid Flow:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="loadFluidFlowSelection.Value"
                (change)="textSelectionChanged(loadFluidFlowSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(loadFluidFlowSelection.Name)"/>
              <label class="units-label">GPM</label>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
